import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "toggler",
        "input"
    ]

    connect() {
        this.toggleInput();
    }

    toggleInput() {
        this.inputTarget.disabled = this.togglerTarget.value !== "true";
    }
}